"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
var icon_1 = require("../icon");
exports.Status = react_1.default.forwardRef(function Status(_a, ref) {
    var _b;
    var _c = _a.icon, icon = _c === void 0 ? "blank" : _c, _d = _a.size, size = _d === void 0 ? "l" : _d, title = _a.title, description = _a.description, operation = _a.operation, className = _a.className, props = tslib_1.__rest(_a, ["icon", "size", "title", "description", "operation", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var isXsSize = size === "xs";
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-status", "size-" + size, className) }, props),
        react_1.default.createElement("div", { className: classPrefix + "-status__img" },
            react_1.default.createElement(icon_1.Icon, { type: classnames_1.default("status-" + icon, { "size-s": isXsSize }) })),
        react_1.default.createElement("div", { className: classPrefix + "-status__content" },
            title && react_1.default.createElement("h4", { className: classPrefix + "-status__title" }, title),
            react_1.default.createElement("div", { className: classPrefix + "-status__detail" }, description)),
        react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-status__operate", (_b = {},
                _b[classPrefix + "-ml-1n"] = isXsSize,
                _b)) }, operation)));
});
exports.Status.displayName = "Status";
//# sourceMappingURL=Status.js.map